package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminStatsResponse(
    @SerialName("total_users") val totalUsers: Long,
    @SerialName("active_listings") val activeListings: Long,
    @SerialName("pending_listing_reports") val pendingListingReports: Long,
    @SerialName("pending_user_reports") val pendingUserReports: Long,
    @SerialName("actions_today") val actionsToday: Long,
    @SerialName("total_queue_size") val totalQueueSize: Long,
    @SerialName("recent_actions") val recentActions: List<RecentActionEntry>,
    @SerialName("oldest_pending_report_age_seconds") val oldestPendingReportAgeSeconds: Long? = null,
    @SerialName("pending_over_24h") val pendingOver24h: Long = 0,
    @SerialName("avg_time_to_action_seconds") val avgTimeToActionSeconds: Long? = null,
    @SerialName("action_mix") val actionMix: List<ActionMixEntry> = emptyList(),
    @SerialName("listings_by_state") val listingsByState: List<GeoStatEntry> = emptyList(),
)

@Serializable
data class ActionMixEntry(
    val action: String,
    val count: Long,
)

@Serializable
data class GeoStatEntry(
    val state: String,
    val count: Long,
)
